import { TOP_BAR_HEIGHT } from '@components/layout/side-nav/layout/layoutStyle';
import { Text } from '@components/ui';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import packageJson from '../../../package.json';
import { SupportSettings } from './support-settings';

const Settings = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        width: '100%',
        maxWidth: 1120,
        // Fill the viewport below the top bar so the version sits at the bottom
        minHeight: `calc(100dvh - ${TOP_BAR_HEIGHT}px)`,
        mx: 'auto',
        px: { xs: 2, md: 4 },
        py: 3,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          overflow: 'hidden',
          border: 1,
          borderColor: 'divider',
          borderRadius: 3,
          bgcolor: 'background.paper',
        }}
      >
        <SupportSettings />
      </Box>
      <Text
        variant="caption"
        tone="muted"
        sx={{ mt: 'auto', pt: 3, textAlign: 'center' }}
      >
        {t('shell.version', { version: packageJson.version })}
      </Text>
    </Box>
  );
};

export default Settings;
